<app-system-alert-banner [types]="bannerAlertTypes"></app-system-alert-banner>
<div [@fadeInAnimation]="prepareRoute(outlet)">
	<router-outlet #outlet="outlet"></router-outlet>
</div>

<app-localize-strings></app-localize-strings>
<app-localize-api-strings></app-localize-api-strings>
